const MainTheme = {
  transparent: 'rgba(0,0,0,0)',
  white: '#ffffff',
  whiteOpacity: 'rgba(255,255,255,0.3)',
  whiteOpacityBright: 'rgba(255,255,255,0.5)',
  black: '#000000',
  overlay: 'rgba(0,0,0,0.5)',
  blue: '#70b2e6',
  background_color: '#ffffff',
  section_color: '#f7f7f7',
  text_color: '#333333',
  gray_light: '#ebebeb',
  gray: '#dfdfdf',
  green: '#72bb53',
  red: '#e61610',
  amber: '#ffb74d',
  danger: '#780b08',
  darkblue: '#008bc5',
  primary: '#00a8e5',
  primaryOpacity: 'rgba(0,168,229,0.2)',
  primaryHover: '#00a8e5',
  secondary: '#6c757d',
  blue_dark: '#0f2638',
  border_color: '#ced4da',
  warning_color: '#fcf8e3',
  warning_icon_color: '#ffb74d',
  lightHover: '#dae0e5',
  disabled_color: '#c0c0c0',
  error_background_color: '#f2dede',
  error_border_color: '#eed3d7',
  overlay_danger: '#fad0cf',
  success: '#3c763d',
};

export default MainTheme;
